import { gql } from 'graphql-request'

export const M_CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($reason: String!, $followUpAnswer: String, $feedback: String) {
    cancelSubscription(reason: $reason, followUpAnswer: $followUpAnswer, feedback: $feedback) {
      ... on CancellationResult {
        success
        cancelledAt
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
